(() => {
  const roots = document.querySelectorAll('[data-live-search]');
  if (!roots.length) return;

  roots.forEach((root) => {
    const input = root.querySelector('[data-live-search-input]');
    const select = root.querySelector('[data-live-search-filter]');
    const wrap = root.querySelector('[data-live-suggest]');
    const resultsEl = root.querySelector('[data-live-suggest-results]');

    if (!input || !wrap || !resultsEl) return;

    const MIN_CHARS = 2;
    const LIMIT = 8;

    let timer = null;
    let abortCtrl = null;
    let lastKey = '';

    const esc = (s) =>
      String(s)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');

    const open = () => (wrap.style.display = 'block');
    const close = () => {
      wrap.style.display = 'none';
      resultsEl.innerHTML = '';
    };

    // selectの現在値から tag を取り出す（value="tag:searchfilter_xxx" を想定）
    const getFilterTag = () => {
      if (!select) return '';
      const opt = select.options?.[select.selectedIndex];
      const v = (opt?.value ?? '').trim(); // "" or "tag:searchfilter_xxx" or "product_type:xxx"

      if (!v) return '';
      const idx = v.indexOf(':');
      if (idx === -1) return '';

      const type = v.slice(0, idx);
      const val = v.slice(idx + 1);

      // 今回は「タグ絞り込み」だけをサジェストに効かせる
      if (type !== 'tag') return '';
      return val;
    };

    const buildMoreUrl = (term, filterTag) => {
     const t = term.trim();
      if (!t) return '/search';

      if (filterTag) {
        const q = `tag:${filterTag} AND ${t}`;
        return `/search?q=${encodeURIComponent(q)}`;
      }
      return `/search?q=${encodeURIComponent(t)}`;
    };


    const render = (items, term, filterTag) => {
      const hasItems = items && items.length > 0;
      const moreQ = filterTag ? `tag:${filterTag} AND ${term.trim()}` : term.trim();
      const moreUrl = `/search?q=${encodeURIComponent(moreQ)}`;
      

      // 一覧HTML
      const listHtml = (items || []).slice(0, LIMIT).map((p) => {
        const title = esc(p.title || '');
        const url = p.url || '#';
        const img = p.image || '';
        return `
          <a class="live-suggest__item" href="${url}">
            <div class="live-suggest__img">
              ${img ? `<img src="${img}" alt="${title}" loading="lazy">` : ''}
            </div>
            <div class="live-suggest__title">${title}</div>
          </a>
        `;
      }).join('');

      if (!hasItems) {
        // ヒット0件：メッセージのみ（もっと見るは出さない）
        resultsEl.innerHTML = `<div class="live-suggest__empty">該当する商品がありません</div>`;
        return;
      }

      // ヒットあり：一覧 + もっと見る
      resultsEl.innerHTML = `
        ${listHtml}
        <a class="live-suggest__more" href="${moreUrl}"><span>もっと見る</span></a>
      `;
    };


    // /search?view=live_suggest を叩く（JSONが返る）
const fetchSuggest = async (term, filterTag) => {
  // ★ここが重要：タグが選ばれている時は q に条件を入れる
  const q = filterTag ? `tag:${filterTag} AND ${term}` : term;

  const url = `/search?view=live_suggest&type=product&q=${encodeURIComponent(q)}&options[prefix]=last`;

  const res = await fetch(url, { signal: abortCtrl.signal, credentials: 'same-origin' });
  if (!res.ok) throw new Error('live_suggest view failed');

  const text = await res.text();
  const json = JSON.parse(text);

  const products = json?.products || [];
  return products.map((p) => ({
    title: p.title,
    url: p.url,
    image: p.image || '',
  }));
};


    const search = async () => {
      const term = input.value.trim();
      const filterTag = getFilterTag();

      if (term.length < MIN_CHARS) {
        close();
        return;
      }

      const key = `${term}__${filterTag}`;
      if (key === lastKey) return;
      lastKey = key;

      if (abortCtrl) abortCtrl.abort();
      abortCtrl = new AbortController();

      open();
      resultsEl.innerHTML = `<div class="live-suggest__empty">検索中...</div>`;

      try {
        const items = await fetchSuggest(term, filterTag);
        render(items, term, filterTag);
      } catch (e) {
        if (e?.name === 'AbortError') return;
        resultsEl.innerHTML = `
          <div class="live-suggest__empty">検索に失敗しました</div>
          <a class="live-suggest__more" href="${buildMoreUrl(term, filterTag)}">もっと見る</a>
        `;
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(search, 180);
    });

    // タグ変更で即反映（入力済みなら更新）
    if (select) {
      select.addEventListener('change', () => {
        lastKey = '';
        if (input.value.trim().length >= MIN_CHARS) search();
      });
    }

    document.addEventListener('click', (e) => {
      if (!root.contains(e.target)) close();
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  });
})();
